import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import PageContainer from '../../layout/PageContainer';
import { CheckCircleFill, XCircleFill, ShareFill } from 'react-bootstrap-icons';

const Integrations = () => {
    const apiList = [
        { name: 'Dow Jones Watchlist API', type: 'Sanctions & PEP Screening', status: 'Connected' },
        { name: 'Core Banking Transaction Feed', type: 'Transaction Ingestion', status: 'Connected' },
        { name: 'OpenSanctions API', type: 'Sanctions & PEP Screening', status: 'Disconnected' },
        { name: 'KYC Document Verification API', type: 'Document Verification', status: 'Connected' },
        { name: 'Adverse Media NLP API', type: 'Negative News Screening', status: 'Connected' },
    ];

    return (
        <PageContainer title="Real-Time API Integrations">
            <p>This module simulates the connection status and management of third-party APIs that provide real-time data for screening and analysis.</p>
            {apiList.map(api => (
                <Card key={api.name} className="mb-3">
                    <Card.Body className="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="mb-1 d-flex align-items-center"><ShareFill className="me-2 text-primary"/>{api.name}</h5>
                            <small className="text-muted">{api.type}</small>
                        </div>
                        <div>
                            {api.status === 'Connected' ? (
                                <Badge bg="success" className="fs-6 d-flex align-items-center"><CheckCircleFill className="me-2"/>{api.status}</Badge>
                            ) : (
                                <Badge bg="danger" className="fs-6 d-flex align-items-center"><XCircleFill className="me-2"/>{api.status}</Badge>
                            )}
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </PageContainer>
    );
};

export default Integrations;